import React from 'react';

export const ResponsiveTableContext = React.createContext();
